import React from "react";

export default function Contact() {
  return (
    <section id="contact" className="section contact">
      <div className="contact-inner">
        <h2>
          Get in
          <br />
          touch
        </h2>
        <div className="contact-links">
          <a target="_blank" rel="noreferrer" href="https://github.com/olisekw">
            GitHub
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.linkedin.com/in/oliver-bujdo%C5%A1-a83942283/"
          >
            LinkedIn
          </a>
          <a href="mailto:oliver.bujdo@gmail.com">oliver.bujdo@gmail.com</a>
        </div>
        {/* add "· Prague" if/when relevant */}
        <p className="contact-location">Stropkov · Košice — Slovakia</p>
      </div>
    </section>
  );
}
